import TabListItem from './TabListItem';

export default TabListItem;
